import { render, staticRenderFns } from "./TabsPortrait.vue?vue&type=template&id=ca5e22b0&"
import script from "./TabsPortrait.vue?vue&type=script&lang=ts&"
export * from "./TabsPortrait.vue?vue&type=script&lang=ts&"
import style0 from "./TabsPortrait.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports